import template from './documentListItem.html';
import { DocumentListItemController } from './documentListItem.controller';

export const documentListItem = {
  name: 'documentListItemComponent',
  restrict: 'E',
  template,
  controller: DocumentListItemController,
  controllerAs: 'vm',
  bindings: {
    documents: '=',
    onClick: '&',
    order: '<',
    reasonTitle: '@',
    reasonText: '@',
    simpleView: '@'
  }
};
